import { render, staticRenderFns } from "./RangeFacet.vue?vue&type=template&id=0f1f6d64&"
import script from "./RangeFacet.vue?vue&type=script&lang=js&"
export * from "./RangeFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/www/finda/current/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f1f6d64')) {
      api.createRecord('0f1f6d64', component.options)
    } else {
      api.reload('0f1f6d64', component.options)
    }
    module.hot.accept("./RangeFacet.vue?vue&type=template&id=0f1f6d64&", function () {
      api.rerender('0f1f6d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "buysearchsell/vue/components/refinements/RangeFacet.vue"
export default component.exports